import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Employee } from 'src/app/models/employee.model';
import { User } from 'src/app/models/user.model';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { UserService } from 'src/app/services/user_service.service';
import { ACHRecordDialogComponent } from './ach_record_dialog/ach_record_dialog.component';
import {CustomerApplicationDialogComponent} from './customer_application_dialog/customer_application_dialog.component';
import { CustomerContractDialogComponent } from './customer_contract_dialog/customer_contract_dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';


@Component({
    selector: 'customer-table',
    templateUrl: './customer_table.component.html',
    styleUrls: ['./customer_table.component.scss'],
    imports: [MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatTooltip, MatIcon, MatMenuTrigger, MatMenu, MatMenuItem, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow]
})
export class CustomerTableComponent implements OnInit {
    employee!: Employee;

    customers: User[] = [];
    customerDataSource = new MatTableDataSource<User>([]);
    customerColumnHeaders: string[] = [
        'firstName',
        'lastName',
        'primaryPhoneNumber',
        'secondaryPhoneNumber',
        'emailAddress',
        'address',
        'action'
    ];

    loading = false;

    constructor(
        private userService: UserService,
        private tokenStorageService: TokenStorageService,
        private router: Router,
        public dialog: MatDialog,
    ) { }

    ngOnInit(): void {
        this.employee = this.tokenStorageService.getUser();
        if (this.employee.employeeRole === 'Admin') {
            this.getAllCustomers();
        } else {
            this.router.navigate(['home']);
        }
    }

    getAllCustomers(): void {
        this.loading = true;

        this.userService
            .getAll(['All'], new Map())
            .subscribe(customers => {
                this.customers = customers;
                this.refreshCustomersTable();
                this.loading = false;
            }, _ => {
                this.loading = false;
            });
    }

    openACHDialog(userId: string): void {
        this.dialog.open(ACHRecordDialogComponent, {
            width: '700px',
            data: userId
        });
    }

    openCustomerApplicationDialog(userId: string): void {
        this.dialog.open(CustomerApplicationDialogComponent, {data: {id: userId}});
    }
    
    openCustomerContractDialog(userId: string): void {
        this.dialog.open(CustomerContractDialogComponent, {width: '700px', data: {id: userId}});
    }

    openCustomerHealthSurvey(userId: string): void {
        this.router.navigate(['question-review', userId]);
    }

    refreshCustomersTable(): void {
        this.customerDataSource.data = this.customers;
    }
}


